import React                                                                                   from 'react';
import PropTypes                                                                               from 'prop-types';
import {openPicturesInViewer}                                                                  from '../components/Gallery/Viewer';
import {openVideoUrlInPlayer}                                                                  from '../components/Gallery/VideoPlayer';
import ContestGridItem                                                                         from './ContestGridItem';
import {VXPay, VXPayAction}                                                                    from './../utils/VXPay';
import Flux                                                                                    from '../flux/Flux';
import {
	generateKey,
	getUrlParams,
	removeUrlParam,
	scrollContainerToElem,
	scrollToElem,
	updateURLParameter
} 																							   from "../utils/CommonUtils";
import HistoryStateHelper                                                                      from "../utils/HistoryStateHelper";
import ReloadHelper                                                                            from "../utils/ReloadHelper";


const PHOTO                     = 'photo';
const VIDEO                     = 'video';
const CONTEST_ITEM_URL_PARAM    = 'mediaIndex';
const STATE_OBJECT_URL_PROPERTY = 'url';

class ContestGrid extends React.Component {

	static onCloseModalBox() {
		const href = removeUrlParam(CONTEST_ITEM_URL_PARAM, window.location.href);
		HistoryStateHelper.setValue(STATE_OBJECT_URL_PROPERTY, href, document.title, href);
	}

	constructor(props) {
		super(props);

		this.loadedAllImages   = false;
		this.loadedImagesCount = 0;
		this.scrollToElementId = null;
		this.gridsplit         = 1100;
		this.mediaType         = null;

        if (HistoryStateHelper.hasKey(STATE_OBJECT_URL_PROPERTY)) {
			const params = getUrlParams(HistoryStateHelper.getValue(STATE_OBJECT_URL_PROPERTY));
			if (params.hasOwnProperty(CONTEST_ITEM_URL_PARAM)) {
				const href                 = removeUrlParam(CONTEST_ITEM_URL_PARAM, HistoryStateHelper.getValue(STATE_OBJECT_URL_PROPERTY));
				HistoryStateHelper.setValue(STATE_OBJECT_URL_PROPERTY, href, document.title, href);
			}
		} else {
			HistoryStateHelper.setValue(STATE_OBJECT_URL_PROPERTY, window.location.href);
		}
		if (props.contestsGridConfig &&
			props.contestsGridConfig.contestGridItems &&
			props.contestsGridConfig.contestGridItems[0] &&
			props.contestsGridConfig.contestGridItems[0].mediaType
		) {
			this.mediaType = props.contestsGridConfig.contestGridItems[0].mediaType;
		}
		this.state                = {
			showFourColums: (window.innerWidth >= this.gridsplit && this.mediaType !== VIDEO),
			preferredCols:  window.innerWidth >= Flux.Constants.Grid2.BREAKPOINT_MIN_WIDTHS.md ? 3 : 2,
		};
		this.onWindowResize       = this.onWindowResize.bind(this);
		this.onImageClick         = this.onImageClick.bind(this);
		this.openMedia            = this.openMedia.bind(this);
		this.openViewerOrRedirect = this.openViewerOrRedirect.bind(this);
		this.onImageLoad          = this.onImageLoad.bind(this);
		this.onVotingChange       = this.onVotingChange.bind(this);
		this.onOpenMediaViewer    = this.onOpenMediaViewer.bind(this);
		this.onAvsModalChange        = this.onAvsModalChange.bind(this);
	}

	componentDidMount() {
		window.addEventListener('resize', this.onWindowResize);
		const shouldOpenMedia = Flux.Contest.getShouldOpenMedia();
		const openMediaConfig = Flux.Contest.getShouldOpenMediaConfig();
		Flux.Contest.addContestVotingChangeListener(this.onVotingChange);
		Flux.Contest.addContestOpenAvsModalChangeListener(this.onAvsModalChange);

		if (shouldOpenMedia && openMediaConfig) {
			this.openMedia(shouldOpenMedia, openMediaConfig);
		} else {
			Flux.Contest.addContestShouldOpenMediaChangeListener(this.openMedia);
		}
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		if (nextProps.contestsGridConfig.contestGridItems.length > this.props.contestsGridConfig.contestGridItems.length) {
			const shouldOpenMedia = Flux.Contest.getShouldOpenMedia();
			const openMediaConfig = Flux.Contest.getShouldOpenMediaConfig();

			if (shouldOpenMedia && openMediaConfig) {
				this.openMedia(shouldOpenMedia, openMediaConfig);
			}
		}
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.onWindowResize);
		Flux.Contest.removeContestShouldOpenMediaChangeListener(this.openMedia);
		Flux.Contest.removeContestVotingChangeListener(this.onVotingChange);
		Flux.Contest.removeContestOpenAvsModalChangeListener(this.onAvsModalChange);
	}

	onOpenMediaViewer(index) {
		const href = updateURLParameter(window.location.href, CONTEST_ITEM_URL_PARAM, this.props.contestsGridConfig.contestGridItems[index].mediaId);
		HistoryStateHelper.setValue(CONTEST_ITEM_URL_PARAM, this.props.contestsGridConfig.contestGridItems[index].mediaId, document.title, href);
	}

	onWindowResize() {
		const documentWidth = window.innerWidth;
		if (documentWidth >= this.gridsplit && !this.state.showFourColums && this.mediaType !== VIDEO) {
			this.setState({
				showFourColums: true,
			});
		} else {
			this.setState({
				showFourColums: false,
				preferredCols:  window.innerWidth >= Flux.Constants.Grid2.BREAKPOINT_MIN_WIDTHS.md ? 3 : 2,
			});
		}
	}

	onImageClick(e, index, mediaType, isElementPinned, needAvs) {
		const showAvs = mediaType === PHOTO && !Flux.Guest.hasAvs() && needAvs;
		if (e && e.stopPropagation) {
			e.stopPropagation();
		}
		if (e && e.preventDefault) {
			e.preventDefault();
		}

		if ((!this.props.contestsGridConfig.guestId && mediaType === PHOTO) || (!this.props.contestsGridConfig.guestId && mediaType === VIDEO)) {
			let action;
			if (Flux.VXMobile.isEntryPage()) {
				VXPay.openSignup();
			} else {
				if(showAvs) {
					action = VXPay.openAVS();
				}
				else {
					action = new VXPayAction(Flux.Constants.ActionTypes.Contest.SET_SHOULD_OPEN_MEDIA, {
						config:     {
							mediaId:     this.props.contestsGridConfig.contestGridItems[index].mediaId,
							mediaType:   mediaType,
							currentPage: this.props.currentPage,
						},
						shouldOpen: true,
					});
				}
				VXPay.openSignupOrLogin({}, action);
			}

			return false;
		}
		this.props.contestsGridConfig.contestGridItems[index].isElementPinned = isElementPinned;
		if(typeof needAvs !== 'undefined') {
			if (!showAvs && typeof this.props.onBeforeImageClick === 'function') {
				this.props.onBeforeImageClick(() => this.openViewerOrRedirect(mediaType, index));
			} else {
				showAvs ? VXPay.openAVS() : this.openViewerOrRedirect(mediaType, index);
			}
		}
	}

	onImageLoad() {
		this.loadedImagesCount++;

		if (this.loadedImagesCount === this.props.contestsGridConfig.contestGridItems.length) {
			this.loadedAllImages = true;
			if (this.props.onAllImagesLoaded) {
				this.props.onAllImagesLoaded();
			}

			// scroll to element if all images were loaded and there is a element id
			if (this.scrollToElementId) {
				if (this.props.isMobile && this.props.containerId) {
					scrollContainerToElem(this.scrollToElementId, this.props.containerId, true);
				} else if (!this.props.isMobile) {
					scrollToElem(this.scrollToElementId, true);
				}
				this.scrollToElementId = null;
			}
		}
	}

	onVotingChange(guestId, contestId, mediaId, isVoted) {
		if (this.props.contestsGridConfig) {
			for (let f = 0; f < this.props.contestsGridConfig.contestGridItems.length; f++) {
				if (this.props.contestsGridConfig.contestGridItems[f].mediaId === mediaId) {
					this.props.contestsGridConfig.contestGridItems[f].isVoted = isVoted;
					break;
				}
			}
		}
	}

	openMedia(shouldOpen, config) {

		if (shouldOpen && config && config.mediaId && config.mediaType && this.props.contestsGridConfig.contestGridItems) {
			let index = null;
			for (let i = 0; i < this.props.contestsGridConfig.contestGridItems.length; i++) {
				const item = this.props.contestsGridConfig.contestGridItems[i];

				if (item && item.mediaId === config.mediaId) {
					index = i;
					break;
				}
			}
			if (index !== null) {
				// scroll to same position as before if all images are loaded
				if (this.loadedAllImages && this.scrollToElementId) {
					if (this.props.isMobile && this.props.containerId) {
						scrollContainerToElem('contest-image-' + config.mediaId, this.props.containerId, true);
					} else if (!this.props.isMobile) {
						scrollToElem('contest-image-' + config.mediaId, true);
					}
					this.scrollToElementId = null;
				} else {
					this.scrollToElementId = 'contest-image-' + config.mediaId;
				}

				// remove listener and reset store
				Flux.Contest.removeContestShouldOpenMediaChangeListener(this.openMedia);
				Flux.Contest.setShouldOpenMedia(false, null);

				if (config.voteMedia) {
					Flux.Contest.addContestMediaVoting(
						this.props.contestsGridConfig.contestGridItems[index].contestId,
						config.mediaId,
						this.props.contestsGridConfig.contestGridItems[index].actorId,
						this.props.contestsGridConfig.guestId,
						this.props.contestsGridConfig.contestGridItems[index].albumId
					);
				} else {
					if (typeof this.props.onBeforeImageClick === 'function') {
						this.props.onBeforeImageClick(() => this.openViewerOrRedirect(config.mediaType, index));
					}  else {
						this.openViewerOrRedirect(config.mediaType, index);
					}
				}
			}
		}

	}

	openViewerOrRedirect(mediaType, index) {
		if (this.props.contestsGridConfig.contestGridItems && this.props.contestsGridConfig.contestGridItems[index]) {
			if (mediaType === PHOTO) {
				const callbacks = {onOpenMediaViewer: this.onOpenMediaViewer, onCloseModalBox: ContestGrid.onCloseModalBox};
				openPicturesInViewer('layer-album-modal', this.props.contestsGridConfig.contestGridItems, true, index, false, true, false, callbacks);
			} else if (mediaType === VIDEO && this.props.contestsGridConfig.contestGridItems[index].videoUrls.length) {
				let galleryContainer = document.getElementById('layer-album-modal');
				if (!galleryContainer) {
					galleryContainer = document.createElement("div");
					galleryContainer.setAttribute("id", 'layer-album-modal');
					document.body.appendChild(galleryContainer);
				}

				const mediaElement    = this.props.contestsGridConfig.contestGridItems[index];
				const onCloseModalBox = ContestGrid.onCloseModalBox;
                openVideoUrlInPlayer(null,
                        this.props.contestsGridConfig.contestGridItems[index].videoUrls,
                        [this.props.contestsGridConfig.contestGridItems[index].origUrl],
                        true, false, null, true, mediaElement,
                        0, onCloseModalBox, '', '', !this.props.isMobile, true, false, false,
                        this.props.contestsGridConfig.contestGridItems[index].webVTT, '', this.props.isMobile, false, galleryContainer);
			} else if (mediaType === VIDEO && !this.props.contestsGridConfig.contestGridItems[index].videoUrls.length && this.props.contestsGridConfig.contestGridItems[index].shopUrl) {
				if (this.props.isMobile) {
					ReloadHelper.reload(this.props.contestsGridConfig.contestGridItems[index].shopUrl);
				} else {
					if (HistoryStateHelper.hasKey(STATE_OBJECT_URL_PROPERTY)) {
						const params = getUrlParams(HistoryStateHelper.getValue(STATE_OBJECT_URL_PROPERTY));
						if (params.hasOwnProperty(CONTEST_ITEM_URL_PARAM)) {
						//	this.props.startMediaIndex = null;
						}
					} else {
						HistoryStateHelper.setValue(STATE_OBJECT_URL_PROPERTY, window.location.href);
					}
					ReloadHelper.reload(this.props.contestsGridConfig.contestGridItems[index].shopUrl);
				}
			}
		}
	}

	onAvsModalChange(openAvsModal) {
		if (openAvsModal) {
			VXPay.openAVS();
		}
	}

	render() {
		let numCols = 1;

		if (!this.props.isMobile) {
			if (this.state.showFourColums) {
				numCols = 4;
			} else {
				numCols = this.state.preferredCols;
			}
		}

		const gridItems   = [];
		const gridHeights = [];
		if (this.props.contestsGridConfig) {
			for (let index = 0; index < this.props.contestsGridConfig.contestGridItems.length; index++) {
				const data = this.props.contestsGridConfig.contestGridItems[index];
				const id   = this.props.contestsGridConfig.contestGridItems[index].mediaId;
				const tile = (
					<ContestGridItem
						key={data.itemHash}
						{...data}
						guestId={this.props.contestsGridConfig.guestId}
						onImageClick={this.onImageClick}
						imageIndex={index}
						mediaType={data.mediaType}
						onImageLoad={this.onImageLoad}
						currentPage={this.props.currentPage}
						openMedia={id === this.props.startMediaIndex}
					/>);
				if (!gridItems[index % numCols]) {
					gridItems[index % numCols]   = [];
					gridHeights[index % numCols] = 0;
				}
				if (index > numCols && data.mediaType === PHOTO) {
					let smallestCol = 0;
					gridHeights.forEach((height, index, gridHeights) => {
						smallestCol = gridHeights[smallestCol] <= height ? smallestCol : index;
					});
					gridItems[smallestCol].push(tile);
					gridHeights[smallestCol] += data.contestPreviewImgs[0].height;
				} else {
					gridItems[index % numCols].push(tile);
					data.mediaType === PHOTO ? gridHeights[index % numCols] += data.contestPreviewImgs[0].height : null;
				}
			}
		}
		const grid = gridItems.map((tiles, index) => <div key={generateKey(null, index)} className={("col-xs-" + (12 / numCols) + " contests__imagerow")}>{tiles}</div>);
		return (
			<div>{grid}</div>
		);
	}
}

ContestGrid.propTypes = {
	contestsGridConfig: PropTypes.arrayOf(PropTypes.object),
	isMobile:           PropTypes.bool,
	currentPage:        PropTypes.number,
	containerId:        PropTypes.string,
	loadMoreUrl:        PropTypes.string,
	onAllImagesLoaded:  PropTypes.func,
	onBeforeImageClick: PropTypes.func,
	startMediaIndex:    PropTypes.number,
	contestArea:        PropTypes.string.isRequired,
};

ContestGrid.defaultProps = {
	contestsGridConfig: null,
	isMobile:           false,
	currentPage:        null,
	containerId:        '',
	onAllImagesLoaded:  () => {
	},
};

export default ContestGrid;
